import React, { useState } from 'react';
import LegalModal from './LegalModal';

/**
 * Footer legal reutilizable que abre modales en lugar de navegar (PWA-friendly)
 * @param {boolean} compact - Si es true, muestra versión compacta para móvil
 */
const LegalFooter = ({ compact = false }) => {
  const [modalType, setModalType] = useState(null);

  const handleOpenModal = (type) => (e) => {
    e.preventDefault();
    setModalType(type);
  };

  const handleCloseModal = () => {
    setModalType(null);
  };

  if (compact) {
    return (
      <>
        <div className="mt-8 pt-6 border-t border-warm-200">
          <div className="flex justify-center items-center gap-3 text-xs text-surface-400">
            <button 
              onClick={handleOpenModal('legal')}
              className="hover:text-surface-600 transition-colors"
            >
              Aviso legal
            </button>
            <span>·</span>
            <button 
              onClick={handleOpenModal('privacy')}
              className="hover:text-surface-600 transition-colors"
            >
              Privacidad
            </button>
            <span>·</span>
            <button 
              onClick={handleOpenModal('terms')}
              className="hover:text-surface-600 transition-colors"
            >
              Términos
            </button>
          </div>
          <p className="text-center text-xs text-surface-400 mt-2">
            © {new Date().getFullYear()} Reserberry
          </p>
        </div>
        <LegalModal 
          isOpen={modalType !== null} 
          onClose={handleCloseModal} 
          type={modalType} 
        />
      </>
    );
  }

  return (
    <>
      <footer className="mt-12 py-6 border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 text-sm text-gray-400">
            <div className="flex items-center gap-4">
              <button 
                onClick={handleOpenModal('legal')}
                className="hover:text-gray-600 transition-colors"
              >
                Aviso legal
              </button>
              <span>·</span>
              <button 
                onClick={handleOpenModal('privacy')}
                className="hover:text-gray-600 transition-colors"
              >
                Política de privacidad
              </button>
              <span>·</span>
              <button 
                onClick={handleOpenModal('terms')}
                className="hover:text-gray-600 transition-colors"
              >
                Términos de servicio
              </button>
            </div>
          </div>
          <p className="text-center text-sm text-gray-400 mt-3">
            © {new Date().getFullYear()} Reserberry. Todos los derechos reservados.
          </p>
        </div>
      </footer>
      <LegalModal 
        isOpen={modalType !== null} 
        onClose={handleCloseModal} 
        type={modalType} 
      />
    </>
  );
};

export default LegalFooter;




